import {Space} from "antd";
import {EmptyState} from "../../../../../../../../empty-state";
import {
  ServiceOrderWorkDeliveryDeliveredWorkCustomerReview,
  ServiceOrderWorkDeliveryDeliveredWorkLinkList,
} from "./link-list";
import {GetStoreServiceOrderApiResponse} from "../../../../../../../../../react-query-hooks/store/services/get-store-service-order/types";
import moment from "moment";

export type ServiceOrderWorkDeliveryDeliveredWorkProps = {
  productServiceDeliveries: GetStoreServiceOrderApiResponse["order"]["productServiceDeliveries"];
};

export function ServiceOrderWorkDeliveryDeliveredWork({
  productServiceDeliveries,
}: ServiceOrderWorkDeliveryDeliveredWorkProps) {
  const sortedProductServiceDeliveries = productServiceDeliveries.sort((a, b) => {
    const aHasComment = !!a.customer_comment;
    const bHasComment = !!b.customer_comment;

    return Number(bHasComment) - Number(aHasComment);
  });
  return (
    <div>
      {productServiceDeliveries.length < 1 ? (
        <EmptyState message="You have not delivered any work for this service" />
      ) : (
        <Space size={16} direction="vertical" style={{display: "flex"}}>
          {sortedProductServiceDeliveries.map((d) => (
            <>
              <ServiceOrderWorkDeliveryDeliveredWorkLinkList
                links={d.delivery
                  .filter((delivery) => !delivery.isUpload)
                  .map((delivery) => ({
                    link: delivery.key,
                  }))}
                date={
                  sortedProductServiceDeliveries.length > 1
                    ? d.customer_comment
                      ? `Delivered on ${moment(d.createdAt).format(
                          "MMMM DD, YYYY • h:mm A"
                        )}`
                      : `Reviewed on ${moment(d.updatedAt).format(
                          "MMMM DD, YYYY • h:mm A"
                        )}`
                    : `Delivered on ${moment(d.createdAt).format(
                        "MMMM DD, YYYY • h:mm A"
                      )}`
                }
              />
              {d.customer_comment && (
                <ServiceOrderWorkDeliveryDeliveredWorkCustomerReview
                  customerReviewComment={d.customer_comment}
                  date={moment(d.updatedAt).format("MMMM DD, YYYY • h:mm A")}
                />
              )}
            </>
          ))}
        </Space>
      )}
    </div>
  );
}
